import { render, staticRenderFns } from "./ItemHome.vue?vue&type=template&id=27747433&scoped=true&"
import script from "./ItemHome.vue?vue&type=script&lang=ts&"
export * from "./ItemHome.vue?vue&type=script&lang=ts&"
import style0 from "./ItemHome.vue?vue&type=style&index=0&id=27747433&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27747433",
  null
  
)

export default component.exports